var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83111 5.35111L10.6489 6.16889L2.59556 14.2222H1.77778V13.4044L9.83111 5.35111ZM13.0311 0C12.8089 0 12.5778 0.0888889 12.4089 0.257778L10.7822 1.88444L14.1156 5.21778L15.7422 3.59111C16.0889 3.24444 16.0889 2.68444 15.7422 2.33778L13.6622 0.257778C13.4844 0.08 13.2622 0 13.0311 0ZM9.83111 2.83556L0 12.6667V16H3.33333L13.1644 6.16889L9.83111 2.83556Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f3ede842042fdc9066da5b4eb112c4d2.svg";
export { ForwardRef as ReactComponent };